
const window = require('window');

// always use polyfill (some implementations are not stable)
delete window.fetch; // this does not work in chrome 45.0.2454.99
window.fetch = undefined;

// eslint-disable-next-line no-restricted-modules
const fetch = require('isomorphic-fetch');

module.exports = fetch;

